import MenuView from '@pages/dashboard/Menu.vue'

export default{
    components:{
        MenuView
    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/pages/dashboard/Dashboard.js